import { getValue, getTotal, bTh } from "../../../../../helpers/functions/report-table";
import "./dashboard-st-table.css";

export default function Caches({ data, getReqPerSec }) {

  const caches = {
    "miss": getValue(data, "miss"),
    "bypass": getValue(data, "bypass"),
    "expired": getValue(data, "expired"),
    "stale": getValue(data, "stale"),
    "updating": getValue(data, "updating"),
    "revalidated": getValue(data, "revalidated"),
    "hit": getValue(data, "hit"),
    "scarce": getValue(data, "scarce")
  }

  return (
    <>
      <h6 className="table-title pb-2">Cache:</h6>

      <div className="report-table-container">
        <table>
          <thead>
          <tr>
            <th colSpan="2">Size</th>
            <th colSpan="4">Traffic</th>
            <th colSpan="9">Cache</th>
          </tr>
          <tr>
            <th>Capacity</th>
            <th>Used</th>
            <th>Sent</th>
            <th>Rcvd</th>
            <th>Sent/s</th>
            <th>Rcvd/s</th>
            <th>Miss</th>
            <th>Bypass</th>
            <th>Expired</th>
            <th>Stale</th>
            <th>Updating</th>
            <th>Revalidated</th>
            <th>Hit</th>
            <th>Scarce</th>
            <th>Total</th>
          </tr>
          </thead>

          <tbody>
          <tr>
            <td>{bTh(data.maxSize)}</td>
            <td>{bTh(data.usedSize)}</td>
            <td>{bTh(data.outBytes + data.overCounts["maxIntegerSize"] * data.overCounts["outBytes"])}</td>
            <td>{bTh(data.inBytes + data.overCounts["maxIntegerSize"] * data.overCounts["inBytes"])}</td>
            <td>{bTh(getReqPerSec("cache-ts", data.outBytes))}</td>
            <td>{bTh(getReqPerSec("cache-tr", data.inBytes))}</td>
            <td>{caches["miss"]}</td>
            <td>{caches["bypass"]}</td>
            <td>{caches["expired"]}</td>
            <td>{caches["stale"]}</td>
            <td>{caches["updating"]}</td>
            <td>{caches["revalidated"]}</td>
            <td>{caches["hit"]}</td>
            <td>{caches["scarce"]}</td>
            <td>{getTotal(caches)}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}
